class Steps {

    constructor(elementIdentifier, options) {

        this.container = document.querySelector(elementIdentifier);

        this.stepsProgressContainer = this.container.querySelector('.steps-progress-container');
        this.stepTabs = this.stepsProgressContainer.querySelectorAll('.step-tab');

        this.stepsContainer = this.container.querySelector('.steps-container');
        this.steps = this.stepsContainer.querySelectorAll('.step');

        this.currentStep = 0;

        for (let i = 0; i < this.stepTabs.length; i++) {
            this.stepTabs[i].addEventListener('click', function (e) {
                this.gotoStep(e.currentTarget.dataset.step);
            }.bind(this));
        }
        $(this.steps).slideUp(0);
        this.gotoStep(0);
    }

    nextStep() {
        this.stepTabs[this.currentStep].classList.add('done');
        this.gotoStep(this.currentStep + 1);

    }

    gotoStep(step) {

        if (step < 0 || step > this.steps.length - 1) {
            return;
        }

        for (let i = 0; i < this.steps.length; i++) {
            if (i == step) {
                $(this.steps[i]).slideDown(200);
            } else {
                $(this.steps[i]).slideUp(200);
            }
        }

        this.steps[this.currentStep].classList.remove('active');
        this.stepTabs[this.currentStep].classList.remove('active');


        this.currentStep = parseInt(step);

        this.stepTabs[this.currentStep].classList.add('open');

        this.steps[this.currentStep].classList.add('active');
        this.stepTabs[this.currentStep].classList.add('active');

    }


}